import React, { useEffect, useState } from "react";
import CloseForm from "../Master/CloseForm";
import "../../css_files/Technician/ViewEditVoucher.css";
import axiosInstance from "../../api";
import moment from "moment";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";

export default function ViewEditReport({
  isEdit,
  setShowReport,
  reportId,
  refresh,
  setrefresh,
}) {
  const [reportData, setReportData] = useState(null);
  const [loading, setloading] = useState(false);
  const [partsDropdown, setPartsDropdown] = useState([]);
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Report/GetSingleReport/${reportId}`
      )
      .then(async (res) => {
        const data = await Promise.all(
          res.data?.serviceReportMasterSubCategories?.map((x) =>
            axiosInstance.get(
              `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetSingleServiceReportCategory/${x?.serviceReportMasterCategoryId}`
            )
          )
        );
        const refinedData = data?.map((x) => x.data);

        const map = new Map();
        res.data?.serviceReportMasterSubCategories?.forEach((x) => {
          if (map.has(x.serviceReportMasterCategoryId)) {
            map.set(x.serviceReportMasterCategoryId, [
              ...map.get(x.serviceReportMasterCategoryId),
              x,
            ]);
          } else {
            map.set(x.serviceReportMasterCategoryId, [x]);
          }
        });

        const arr = [];
        for (const [key, value] of map) {
          const category = refinedData?.find((x) => x.id == key);
          arr.push({
            id: key,
            name: category?.name,
            remarks: category?.remarks,
            serviceReportMasterSubCategories: value,
          });
        }

        const quotationData = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/api/v1/Quotation/GetQuotationByTicketId/${res.data?.ticket?.seriesId}`
        );

        const allsubcategories = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/api/v1/ServiceReportMaster/GetCategoriesandSubCategoriesByTicketId?seriesId=${res.data?.ticket?.id}&reportType=${res.data?.reportType}`
        );

        const finalData = {
          ...res.data,
          parts: res.data.partsReplaced?.map((x) => x.id),
          serviceReportMasterSubCategories: arr,
          quotationData: quotationData.data,
          allsubcategories: allsubcategories.data,
        };

        setReportData(finalData);
      })
      .catch(console.log);
  }, [reportId]);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    const formdata = new FormData();
    formdata.append("Id", reportId);
    formdata.append("ServiceDate", reportData.serviceDate);
    formdata.append("ServiceDescription", reportData.serviceDescription);
    formdata.append("CustomerFeedback", reportData.customerFeedback);
    reportData.parts.forEach((p) => formdata.append("Parts", p));

    const apiCall = axiosInstance.put(
      `${process.env.REACT_APP_API_URL}/api/Report/UpdateReport`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    apiCall
      .then((res) => {
        setrefresh(!refresh);
        setShowReport(false);
        toast.success(res?.data, {
          position: "bottom-center",
          theme: "dark",
        });
      })
      .catch(console.log)
      .finally(() => setloading(false));
  }

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetAllTicketIds`)
      .then((res) => setTickets(res.data))
      .catch(console.log);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Parts/GetAllPartsDropdown`)
      .then((res) => setPartsDropdown(res.data))
      .catch(console.log);
  }, []);

  const generateHTML = (data) => {
    const checked = "☑";
    const unchecked = "☐";
    return `<html>
    <head>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          font-size: 10px;
          box-sizing: border-box;
        }
  
        table {
          width: 100%;
          border-collapse: collapse;
        }
  
        td,
        th {
          border: 1px solid black;
          padding: 3px;
          vertical-align: top;
        }
  
        .no-border td {
          border: none;
        }
  
        .center {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }
  
        .center span {
          font-size: 1rem;
        }
  
        .heading {
          font-size: 18px;
          font-weight: bold;
        }
  
        .sub-heading {
          font-size: 12px;
          font-weight: bold;
        }
  
        .checkbox {
          width: 10px;
          height: 10px;
          border: 1px solid black;
          display: inline-block;
        }
        .servicing-observation {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          border-collapse: collapse;
        }

        .servicing-observation blockquote {
          display: flex;
          align-items: center;
          gap: 5px;
          border: 1px solid black;
          justify-content: space-between;
          padding: 3px;
        }

        .center span{
          font-size: 14px;
        }
      </style>
    </head>
  
    <body>
      <!-- HEADER -->
  
      <div class="center">
        <span style="font-size: 1.7rem; font-weight: 600;">ROSS BOILERS</span>
        <span style="font-size: 1.4rem; font-weight: 600;">SERVICE DEPARTMENT</span>
        <span>An ISO 9001:2015 Certified Company</span>
        <span>Email: service@rossindia.com, sales@rossindia.com, csa@rossindia.com</span>
        <span>Website: www.rossindia.com</span>
        
        <span>Customer Care: +91 9922433675, +91 9422023803</span>
        <span>GSTIN No.: 27ADFPS7985L1ZJ</span>
      </div>
      <h1><center>SERVICE REPORT</center></h1>
      <br />
  
      <!-- CUSTOMER DETAILS -->
  
      <table>
        <tr>
          <td width="50%">Client : ${
            data?.ticket?.newEnquiry?.customer?.orgName
          }</td>
  
          <td width="50%">Service Call No : </td>
        </tr>
  
        <tr>
          <td rowspan="2">Address : ${
            data?.ticket?.newEnquiry?.billToAddress?.addressType
          } - ${
      data?.ticket?.newEnquiry?.billToAddress?.officeName ||
      data?.ticket?.newEnquiry?.billToAddress?.factoryName
    }, ${data?.ticket?.newEnquiry?.billToAddress?.address1}, ${
      data?.ticket?.newEnquiry?.billToAddress?.address2
    }, ${
      data?.ticket?.newEnquiry?.billToAddress?.cityObj?.name ??
      data?.ticket?.newEnquiry?.billToAddress?.cityName
    }, ${
      data?.ticket?.newEnquiry?.billToAddress?.stateObj?.name ??
      data?.ticket?.newEnquiry?.billToAddress?.stateName
    }, ${data?.ticket?.newEnquiry?.billToAddress?.country}, ${
      data?.ticket?.newEnquiry?.billToAddress?.pincode
    }</td>
  
          <td>Unit / Model : ${
            data?.ticket?.newEnquiry?.customerBoiler?.boiler?.head
          } - ${
      data?.ticket?.newEnquiry?.customerBoiler?.boilerSeriess?.seriesCode
    }</td>
        </tr>
  
        <tr>
          <td>Contact Person : ${
            data?.ticket?.newEnquiry?.contactCentre?.salutation
          } ${data?.ticket?.newEnquiry?.contactCentre?.name}</td>
        </tr>
  
        <tr>
          <td>Serial No : ${data?.ticket?.newEnquiry?.customerBoiler?.srNo}</td>
          <td>Total No. of Days: ${Math.floor(
            (new Date(data?.ticket?.endDate) -
              new Date(data?.ticket?.startDate)) /
              (1000 * 60 * 60 * 24)
          )}</td>
        </tr>
  
        <tr>
          <td>Mobile No : ${
            data?.ticket?.newEnquiry?.contactCentre?.phoneNumber
          }</td>
          <td>Visit Category : ${
            data?.reportType == "Servicing" ? checked : unchecked
          } Servicing ${
      data?.reportType == "Commissioning" ? checked : unchecked
    } Commissioning</td>
        </tr>
  
        <tr>
          <td>From : ${new Date(data?.ticket?.startDate).toDateString()}</td>
          <td>To : ${new Date(data?.ticket?.endDate).toDateString()}</td>
        </tr>
        <tr>
          <td colspan="2">
            Equipment Status/ Customer Complaint : ${
              data?.ticket?.newEnquiry?.servicesLookingFor
            }
          </td>
        </tr>
      </table>
  
      <br />
  
      <!-- OBSERVATION TABLE -->
  
      <div class="servicing-observation">
        <blockquote style="grid-column: span 3">
          <p>Summary of Observations / Work Done</p>
        </blockquote>
  
        ${data?.serviceReportMasterServiceSubCategories
          ?.map(
            (x) => `
        <blockquote>
          <p>${x?.serviceReportMasterServiceSubCategory?.id}. ${
              x?.serviceReportMasterServiceSubCategory?.name
            }</p>
          <p>${x?.count ?? ""}</p>
        </blockquote>
        `
          )
          .join("")}
        
      </div>
  
      <br />
  
      <!-- ACTION TAKEN -->
  
      ${
        data?.reportType == "Commissioning"
          ? `<div class="servicing-observation">
        <blockquote style="grid-column: span 3">
          <p>Actions Taken</p>
        </blockquote>
  
        ${data?.allsubcategories?.serviceReportMasterCategories
          ?.map(
            (x, i) => `
        <blockquote style="justify-content:start; gap: 1rem;">
          <p>${i + 1}. ${x?.name} ${
              data?.serviceReportMasterSubCategories?.some((y) => y.id == x.id)
                ? checked
                : unchecked
            }</p>
          <ol>
          ${x?.serviceReportMasterSubCategories
            ?.map(
              (y) =>
                `
             <li>${y?.name} ${
                  data?.serviceReportMasterSubCategories
                    ?.flatMap((x) => x.serviceReportMasterSubCategories)
                    ?.some((z) => z.id == y.id)
                    ? checked
                    : unchecked
                }</li>
            `
            )
            .join("")}
          </ol>
        </blockquote>
        `
          )
          .join("")}
        
      </div>`
          : ""
      }
  
      <br />
  
      <!-- SPARES 
  
      <table>
        <tr>
          <th colspan="8">Spares Delivered / Required / Recommended</th>
        </tr>
  
        <tr>
          <th>Sr</th>
          <th>Item</th>
          <th>Qty</th>
          <th>Amount</th>
          <th>Sr</th>
          <th>Item</th>
          <th>Qty</th>
          <th>Amount</th>
        </tr>
  
        ${Array.from({ length: 8 })
          .map(
            (_, i) => `
        <tr>
          <td>${i + 1}</td>
          <td></td>
          <td></td>
          <td></td>
          <td>${i + 9}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        `
          )
          .join("")}
      </table> -->
  
      <br />
  
      <!-- TOTALS 
  
      <table>
        <thead>
          <tr>
          <th>Name</th>
          ${
            data?.quotationData?.enquiryType == "Service"
              ? `
          <th>No. of Days (${data?.quotationData?.symbol})</th>
          <th>Price Per Day (${data?.quotationData?.symbol})</th> 
          `
              : ""
          }
          <th>Total (${data?.quotationData?.symbol})</th>
          </tr>
        </thead>
        <tbody>
           ${data?.quotationData?.items
             ?.map(
               (x) => `
          <tr>
            <td>${x?.description}</td>
            <td>${x?.noOfDays}</td>
            <td>${x?.pricePerDay}</td>
            <td>${x?.total}</td>
          </tr>
          `
             )
             .join("")}
          <tr>
            <td colspan=${
              data?.quotationData?.enquiryType == "Service" ? "3" : "1"
            }>Final Total</td>
            <td>${data?.quotationData?.finalTotal}</td>
          </tr>
          <tr>
            <td colspan=${
              data?.quotationData?.enquiryType == "Service" ? "3" : "1"
            }>GST</td>
            <td>${data?.quotationData?.gstAmount}</td>
          </tr>
          <tr>
            <td colspan=${
              data?.quotationData?.enquiryType == "Service" ? "3" : "1"
            }>Discount</td>
            <td>${data?.quotationData?.discountValue}</td>
          </tr>
          <tr>
            <td colspan=${
              data?.quotationData?.enquiryType == "Service" ? "3" : "1"
            }>Grand Total</td>
            <td>${data?.quotationData?.grandTotal}</td>
          </tr>
        </tbody>
        
      </table> -->
  
      <br />
  
      <!-- FOOTER -->
  
      <table>
        <tr>
          <td>Suggestion To Customer: </td>     
        </tr>
        <tr>
          <td style="height: 1rem;"></td>
        </tr>
        <tr>
          <td style="height: 1rem;"></td>
        </tr>
  
        <tr>
          <td>Customer Comments / Expectations: </td> 
        </tr>
        <tr>
          <td style="height: 1rem;"></td>
        </tr>
        <tr>
          <td style="height: 1rem;"></td>
        </tr>
      </table>
  
      <br /><br />
  
      <table class="no-border">
        <tr>
          <td>
            For Ross Boilers<br /><br />
            Service Technician: ${data?.technicianUserId}
          </td>
  
          <td style="text-align: right">
            <p>Customer Signature</p>
            <br/><br/>
            <p>Name:</p>
            
          </td>
        </tr>
      </table>
    </body>
  </html>`;
  };

  return (
    <div className="view-edit-voucher-technician">
      <form onSubmit={handleSubmit}>
        <center>
          <h2>{`${isEdit ? "Edit" : "View"} Report`}</h2>
        </center>
        <i
          class="fa-solid fa-file-pdf fa-2x"
          title="Export to Pdf"
          onClick={() => {
            const html = generateHTML(reportData);
            const element = document.createElement("div");
            element.innerHTML = html;

            const options = {
              margin: 0.5,
              filename: `ServiceReport${reportData?.ticket?.seriesId}.pdf`,
              image: { type: "jpeg", quality: 1 },
              html2canvas: { scale: 2 },
              jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
              },
            };

            html2pdf().set(options).from(element).save();
          }}
        ></i>
        <blockquote style={{ flexDirection: "row" }}>
          <label style={{ fontWeight: 600 }}>Report Type:</label>

          <p>{reportData?.reportType}</p>
        </blockquote>
        <blockquote style={{ flexDirection: "row" }}>
          <label style={{ fontWeight: 600 }}>Ticket Id:</label>

          <p>{tickets?.find((x) => x.id == reportData?.ticketId)?.seriesId}</p>
        </blockquote>
        <blockquote style={{ flexDirection: "row" }}>
          <label style={{ fontWeight: 600 }}>Boiler Head - Series:</label>
          <p>
            {reportData?.ticket?.newEnquiry?.customerBoiler?.boiler?.head} -{" "}
            {
              reportData?.ticket?.newEnquiry?.customerBoiler?.boilerSeriess
                ?.seriesCode
            }
          </p>
        </blockquote>

        <blockquote>
          <label style={{ fontWeight: 600 }}>
            Service Report SubCategories:
          </label>
          {reportData?.serviceReportMasterServiceSubCategories?.map((x) => (
            <ol>
              <li style={{ listStyle: "none" }}>
                <p>
                  {x.serviceReportMasterServiceSubCategoryId}.{" "}
                  {x.serviceReportMasterServiceSubCategory?.name}
                </p>
              </li>
              <p>Count: {x.count}</p>
            </ol>
          ))}
        </blockquote>
        {reportData?.reportType == "Commissioning" && (
          <blockquote>
            <label style={{ fontWeight: 600 }}>
              Categories and SubCategories:
            </label>
            {reportData?.serviceReportMasterSubCategories?.map((x) => (
              <ul>
                <li>{x?.name}</li>
                <ol style={{ listStylePosition: "inside" }}>
                  {x?.serviceReportMasterSubCategories?.map((y) => (
                    <li>{y.name}</li>
                  ))}
                </ol>
                <li>Remarks : {x?.remarks}</li>
              </ul>
            ))}
          </blockquote>
        )}

        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: 600 }}>Service Date:</label>
          {isEdit ? (
            <input
              type="date"
              placeholder="Enter Report Date"
              required
              value={moment(new Date(reportData?.serviceDate)).format(
                "YYYY-MM-DD"
              )}
              onChange={(e) => {
                setReportData({
                  ...reportData,
                  serviceDate: e.target.value,
                });
              }}
            />
          ) : (
            <p>
              {moment(new Date(reportData?.serviceDate)).format("YYYY-MM-DD")}
            </p>
          )}
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: 600 }}>Description:</label>
          {isEdit ? (
            <textarea
              value={reportData?.serviceDescription}
              placeholder="Enter Description"
              rows={4}
              onChange={(e) => {
                setReportData({
                  ...reportData,
                  serviceDescription: e.target.value,
                });
              }}
              maxLength="500"
            ></textarea>
          ) : (
            <p>{reportData?.serviceDescription}</p>
          )}
        </blockquote>
        <blockquote>
          <label style={{ fontWeight: 600 }}>Parts:</label>
          <Select
            isSearchable
            options={partsDropdown}
            onChange={(values) => {
              if (values)
                setReportData({
                  ...reportData,
                  parts: values.map((x) => x.value),
                });
            }}
            value={partsDropdown?.filter((x) =>
              reportData?.parts?.includes(x.value)
            )}
            isClearable
            isMulti
            isDisabled={isEdit === false}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            menuPlacement="top"
            placeholder="Select Parts"
            styles={{
              container: (base) => ({
                ...base,
                width: "100%",
              }),
              placeholder: (base) => ({
                ...base,
                color: "black",
              }),
              control: (base, state) => ({
                ...base,
                borderColor: "black",
                "&:hover": {
                  borderColor: "black",
                },
                boxShadow: "none",
              }),
              singleValue: (base) => ({
                ...base,
                color: "black",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "black",
                "&:hover": {
                  color: "black",
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: "black",
              }),
              noOptionsMessage: (base) => ({
                ...base,
                color: "black",
              }),
            }}
          />
        </blockquote>
        <blockquote style={{ flexDirection: isEdit === false && "row" }}>
          <label style={{ fontWeight: 600 }}>Customer Feedback:</label>
          {isEdit ? (
            <textarea
              value={reportData?.customerFeedback}
              placeholder="Enter Customer Feedback"
              rows={4}
              onChange={(e) => {
                setReportData({
                  ...reportData,
                  customerFeedback: e.target.value,
                });
              }}
              style={{ resize: "vertical" }}
              maxLength="500"
            ></textarea>
          ) : (
            <p>{reportData?.customerFeedback}</p>
          )}
        </blockquote>
        <blockquote>
          <label style={{ fontWeight: 600 }}>Signature:</label>
          <img
            height={250}
            width={250}
            src={`${process.env.REACT_APP_API_URL}/signatures/${reportData?.customerSignature}`}
          />
        </blockquote>

        {isEdit && (
          <button type={loading ? "button" : "submit"}>
            {loading ? "Please Wait..." : "Submit"}
          </button>
        )}
        <CloseForm close={setShowReport} />
      </form>
    </div>
  );
}
